export function createTimeBar({ onSpeed, onReseed, initialSpeed = 1 }) {
  const bar = document.createElement('div');
  bar.id = 'time-bar';
  bar.className = 'time-bar';

  const label = document.createElement('span');
  label.className = 'time-label';
  label.textContent = '时间流速';
  bar.appendChild(label);

  const speeds = [0, 1, 2, 5, 10, 50];
  const buttons = [];
  const currentLabel = document.createElement('span');
  currentLabel.className = 'time-current';
  currentLabel.textContent = '当前：' + (initialSpeed === 0 ? '暂停' : initialSpeed + '×');

  let timeScale = initialSpeed;

  speeds.forEach((s) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.dataset.speed = String(s);
    btn.textContent = s === 0 ? '⏸' : s + '×';
    btn.addEventListener('click', () => {
      timeScale = s;
      paint();
      onSpeed(s);
    });
    buttons.push(btn);
    bar.appendChild(btn);
  });

  const resetBtn = document.createElement('button');
  resetBtn.type = 'button';
  resetBtn.textContent = '↻';
  resetBtn.title = '重新生成星系';
  resetBtn.addEventListener('click', () => onReseed('manual'));
  bar.appendChild(resetBtn);
  bar.appendChild(currentLabel);

  function paint() {
    buttons.forEach((b) => {
      const active = Number(b.dataset.speed) === timeScale;
      b.classList.toggle('active', active);
    });
    currentLabel.textContent = '当前：' + (timeScale === 0 ? '暂停' : timeScale + '×');
  }

  paint();
  document.body.appendChild(bar);

  return {
    get speed() {
      return timeScale;
    },
    setSpeed(s) {
      timeScale = s;
      paint();
    },
    el: bar,
  };
}
